import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeDashboard } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriode } from '../DashbordBackOffice';
import { getInfosGraphAosCount } from './InterfacesDashboards';
import { StatutsMisionEnum } from './StatutMissionExpert';

function StatutMissions({allStatusMissions,filtreClient,selectedClient,clientName,width,height}){

    StatutMissions.propTypes = {
        allStatusMissions: PropTypes.any,
        filtreClient: PropTypes.any,
        selectedClient: PropTypes.any,
        clientName: PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const { inputSize } = useWindowSize();
    const [filtreSourceMission, setFiltreSourceMission] = useState(['all']);
    const [selectedClientCheckBox, setSelectedClientCheckBox] = useState(['all']);
    const [selectedStatutMission, setSelectedStatutMission] = useState(['encours']);
    const [selectedPeriodMission, setSelectedPeriodMission] = useState('thisMonth'); // Default selected period
    const [customDateRangeMission, setCustomDateRangeMission] = useState({});
    const { i18n } = useTranslation();
    const sourceMission = [
        {label:'AO',value:'ao'},
        {label:'Cvtheque',value:'cvtheque'},
        {label:'All',value:'all'}
    ];
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [chartDataStatusMission, setChartDataStatusMission] = useState({
        series: [],
        chart: {
            type: 'bar',
            //stackType: '50%',
            toolbar: {
                show: true
            },
            zoom: {
                enabled: true
            }

        },
        options: {
            labels: [],
            bar : {
                columnWidth: '20px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '15%',
                    endingShape: 'rounded',
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    },
                }
            }],
            legend: {
                position: 'bottom',
                offsetY: 40
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
            fill: {
                opacity: 1
            }
        },
    });

    useEffect(()=>{
        if(Array.isArray(allStatusMissions)){
            var filteredData;
            filteredData=allStatusMissions;
            if(filtreClient){
                if (!selectedClientCheckBox.includes('all')) {
                    filteredData = filteredData.filter(
                        (item) => selectedClientCheckBox.includes(item.companyDataId)
                    );
                }
            }

            filteredData=filtreListPeriode(filteredData,selectedPeriodMission,customDateRangeMission);

            if (!selectedStatutMission.includes('all')) {
                filteredData = filteredData.filter(
                    (item) => selectedStatutMission.includes(item.statutMission)
                );
            }

            if (filtreSourceMission != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.sourceMission == filtreSourceMission
                );
            }

            const {dates,data}=getInfosGraphAosCount(filteredData,filtreClient,selectedClient,clientName);

            setChartDataStatusMission((prevState) => {
                return {
                    ...prevState,

                    series: data,
                    options: {
                        ...prevState.options,
                        xaxis: {
                            categories: dates
                        },
                    },
                };
            });
        }
    },[selectedClient,allStatusMissions,selectedClientCheckBox,customDateRangeMission,selectedStatutMission,filtreSourceMission]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Analyse des missions')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodMission}
                            setSelectedPeriod={setSelectedPeriodMission}
                            setCustomDateRange={setCustomDateRangeMission}
                            listeVal={PeriodeDashboard}

                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'25%'}}>
                            <ThemeProvider theme={FieldComponentFont}>
                                <FormControl style={{width:'100%'}}>
                                    <InputLabel
                                        shrink={true}
                                        id="demo-multiple-checkbox-label"
                                    >{i18n.t('Clients')} </InputLabel>
                                    <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        label='Clients'
                                        multiple
                                        value={selectedClientCheckBox}
                                        onChange={(event)=>{
                                            const {
                                                target: { value },
                                            } = event;
                                            //console.log('typeof value ===',(typeof value === 'string' ? value.split(',') : value));
                                            setSelectedClientCheckBox(
                                                // On autofill we get a stringified value.
                                                typeof value === 'string' ? value.split(',') : value,
                                            );
                                            if(value.length>0){
                                                if (value[value.length - 1] == 'all') {
                                                    setSelectedClientCheckBox(['all']);
                                                } else {
                                                    // If 'all' was selected before, remove it from selectedClientCheckBox
                                                    const updatedSelected = value.includes('all')
                                                        ? value.filter((item) => item !== 'all')
                                                        : value;
                                                    console.log('updatedSelected',updatedSelected);

                                                    setSelectedClientCheckBox(updatedSelected);
                                                }
                                            }
                                        }}
                                        size={inputSize}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', background: 'white' }}
                                        input={<OutlinedInput label="Clients" />}
                                        renderValue={(selected) => {
                                            return selected
                                                .map((id) => {
                                                    const selectedOption = selectedClient.find(
                                                        (element) => element._id === id
                                                    );
                                                    return i18n.t(selectedOption?.label);
                                                })
                                                .join(', ');
                                        }}
                                        MenuProps={MenuProps}
                                    >
                                        {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                            <MenuItem
                                                key={element._id}
                                                value={element._id}
                                            >
                                                <Checkbox checked={selectedClientCheckBox.includes(element._id)} />
                                                <ListItemText primary={i18n.t(element.label)} />
                                            </MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </ThemeProvider>

                            {/*<SelectUser
                                selectedClientvalue={selectedClientMission}
                                setSelectedClientvalue={setSelectedClientMission}
                            />*/}
                        </div>
                    }

                    <div style={{width:'25%'}}>
                        <ThemeProvider theme={FieldComponentFont}>
                            <FormControl style={{width:'100%'}}>
                                <InputLabel
                                    shrink={true}
                                    id="demo-multiple-checkbox-label"
                                >{i18n.t('Statut mission')} </InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    label='Statut mission'
                                    value={selectedStatutMission}
                                    onChange={(event)=>{
                                        const {
                                            target: { value },
                                        } = event;
                                        console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                        setSelectedStatutMission(
                                        // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value,
                                        );
                                        if(value.length>0){
                                            if (value[value.length - 1] == 'all') {
                                                setSelectedStatutMission(['all']);
                                            } else {
                                                // If 'all' was selected before, remove it from selectedClientCheckBox
                                                const updatedSelected = value.includes('all')
                                                    ? value.filter((item) => item !== 'all')
                                                    : value;
                                                console.log('updatedSelected',updatedSelected);

                                                setSelectedStatutMission(updatedSelected);
                                            }
                                        }
                                    }}
                                    size={inputSize}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    style={{ width: '100%', background: 'white' }}
                                    input={<OutlinedInput label="Statut mission" />}
                                    renderValue={(selected) => {
                                        return selected
                                            .map((value) => {
                                                const selectedOption = StatutsMisionEnum.find(
                                                    (element) => element.value === value
                                                );
                                                return i18n.t(selectedOption?.label);
                                            })
                                            .join(', ');
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    {Array.isArray(StatutsMisionEnum) && StatutsMisionEnum?.map((element) => (
                                        <MenuItem
                                            key={element.value}
                                            value={element.value}
                                        >
                                            <Checkbox checked={selectedStatutMission.includes(element.value)} />
                                            <ListItemText primary={i18n.t(element.label)} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectComponent
                            label={i18n.t('Source')}
                            val={filtreSourceMission}
                            name='statusAoCandidatures'
                            setVal={(event)=>{
                                setFiltreSourceMission(event.target.value);
                            }}
                            listVal={sourceMission}
                        />
                    </div>
                </div>
                <div style={{height:'400px',width:'100%'}}>
                    <Chart
                        options={chartDataStatusMission.options}
                        series={chartDataStatusMission.series}
                        type="bar"
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );

}
export default StatutMissions;